import { ListTeam } from 'generated-graphql/types';
import {
  getUpsertTalentPoolSchema,
  TeamFieldState
} from 'modules/candidate-profile/forms/schema';
import {
  getTeamField,
  getUpsertTalentPoolFields
} from 'modules/candidate-profile/forms/fields';

// The create and edit talent list form. currentTeams are the edited list's teams.
export const getTalentListForm = (currentTeams: ListTeam[] = []) => {
  const teamState: TeamFieldState = { isRequired: false, sendsTeams: false };

  return {
    schema: getUpsertTalentPoolSchema(teamState),
    fields: getUpsertTalentPoolFields(
      getTeamField({ currentTeams, teamState })
    ),
    defaultTeamIds: currentTeams.map(({ id }) => id),
    teamState
  };
};
